import { memo } from "react";
import PaymentMethodButtons from "./payment-method-buttons";
import { PaymentMethodsEnum } from "@zenith/features/Payments/types";

export interface PaymentMethodComponentProps {
  selectedPaymentMethod: PaymentMethodsEnum | null;
  setSelectedPaymentMethod: (method: PaymentMethodsEnum | null) => void;
}

const PaymentMethodComponent = memo(function PaymentMethodComponent({
  selectedPaymentMethod,
  setSelectedPaymentMethod,
}: PaymentMethodComponentProps) {
  return (
    <div className="flex w-full flex-col rounded-1.25l p-6">
      <h2 className="mb-8 w-full text-left text-2xl">Confirm Payment Method</h2>
      <PaymentMethodButtons
        dashboard={false}
        btnHeight="6"
        btnWidth="6"
        bg="neutral-200"
        selectedPaymentMethod={selectedPaymentMethod}
        onSelectPaymentMethod={setSelectedPaymentMethod}
      />
      <hr className="w-full text-black" />
    </div>
  );
});

export default PaymentMethodComponent;
